'use strict';

import { Dropdown } from './dropdown.js';

export class DropdownMenuadlistingview extends Dropdown {
	constructor(component_key) {
		super(component_key);
		// Cache the last visited session items container
		this.$last_visited_session_items = jQuery('.js-last_visited_session__items');
		this.last_viewed();
	}
	add_events() {
		const option_selector = `.js-${this.id}_option`;
		this.$selected.on('click', option_selector, (event) => {
			const handler = jQuery(event.currentTarget).hasClass('js-show_images')
				? this.selected_click_handler_login
				: this.selected_click_handler;
			handler.call(this, event);
		});
		this.$list.on('click', option_selector,
			this.option_click_handler.bind(this)
		);
		this.$selected.on('keydown', (e) => {
			if(yalwa.basics.is_space_bar_or_enter_pressed(e)) {
				this.$selected.find(option_selector).trigger('click');
			}
		});
		this.$list.on('keydown', option_selector, (e) => {
			if(yalwa.basics.is_space_bar_or_enter_pressed(e)) {
				jQuery(e.currentTarget).trigger('click');
			}
		});
		jQuery(`.js-${this.id}`).on('blur', this.close_all.bind(this));
	}
	selected_click_handler_login(event) {
		yalwa.basics.auth.module.show_dialog(event);
	}
	
	option_click_handler(event) {
		super.option_click_handler(event);
		const $element = jQuery(event.currentTarget);
		yalwa.basics.ga.event({
			category: 'bst_view',
			action: $element.data('view'),
			label: null
		});
		const views = ['view_no_image',  'view_simple', 'view_detailed']
		const $posting_listings = jQuery('.js-bst_list_item');
		views.forEach((view, index) => {
			$posting_listings.removeClass(view);
		})
		$posting_listings.addClass(`view_${$element.data('view')}`);
		if ($element.data('view') == 'detailed') {
			jQuery('.last_visited_session__items .js-bst_list_item').removeClass('view_detailed').addClass('view_simple');
		}
		const data = yalwa.basics.get_cookie(this.component.cookie_name) ? JSON.parse(atob(yalwa.basics.get_cookie(this.component.cookie_name))) : {};
		const key = this.component.leaf_category || 'nationwide';
		(data[yalwa.v.countryID] ||= {})[key] = $element.data('view');
		const json_sting = JSON.stringify(data);
		const base64_string = btoa(json_sting);
		yalwa.basics.set_cookie(this.component.cookie_name, base64_string);
		yalwa.browse.update_description_snippets();
	}
	last_viewed() {
		const data = yalwa.basics.get_cookie(this.component.cookie_name) ? JSON.parse(atob(yalwa.basics.get_cookie(this.component.cookie_name))) : {};;
		const view = data[yalwa.v.countryID]?.[this.component.leaf_category];
		if (view == undefined && (yalwa.v.l1 == 'L' || yalwa.v.l1 == 'J')) {
			jQuery('.last_visited_session__items .js-bst_list_item').removeClass('view_detailed view_simple').addClass('view_no_image');
		}
		if (view == 'no_image') {
			jQuery('.last_visited_session__items .js-bst_list_item').removeClass('view_detailed view_simple').addClass('view_no_image');
		}
	}
}
